var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import AntdEmpty from 'antd/es/empty';
import classnames from 'classnames';
import usePrefixCls from '../hooks/usePrefixCls';
import DefaultImg from './assets/empty.png';
const INIT_HEIGHT = 100;
const Empty = (_a) => {
    var { className, imageStyle, image = DefaultImg, prefixCls: customizePrefixCls } = _a, rest = __rest(_a, ["className", "imageStyle", "image", "prefixCls"]);
    const prefixCls = usePrefixCls('empty', customizePrefixCls);
    const classNames = classnames(prefixCls, className);
    const getImageStyle = () => {
        const initStyle = {
            height: INIT_HEIGHT
        };
        if (imageStyle) {
            return Object.assign(Object.assign({}, initStyle), imageStyle);
        }
        return Object.assign({}, initStyle);
    };
    return React.createElement(AntdEmpty, Object.assign({}, rest, { className: classNames, image: image, imageStyle: getImageStyle() }));
};
Empty.PRESENTED_IMAGE_DEFAULT = AntdEmpty.PRESENTED_IMAGE_DEFAULT;
Empty.PRESENTED_IMAGE_SIMPLE = AntdEmpty.PRESENTED_IMAGE_SIMPLE;
export default Empty;
